module.exports = __webpack_public_path__ + "img/album07_37.8ae24ef0.jpg";